import { useCallback, useEffect, useState } from "react";
import { API } from "../../../services/api";
import { TRAITEMENTS_PAGE_SIZE, hasNextPage, patientKey, retraitedTraitement, traitementsPageFromResponse } from "../model/suiviLivraisonRules";

// Traitements du patient sélectionné, chargés par pages de commandes. Sur l'onglet patient, le premier patient de
// la liste est sélectionné dès que la sélection courante n'y figure plus.
export function usePatientTraitements(grouped, active) {
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const select = useCallback((patient, nextPage = 0) => {
        setSelectedPatient(patient);
        if (nextPage === 0) {
            setItems([]);
            setPage(0);
            setTotalPages(0);
        }
        if (!patient?.patientId) return;
        setLoading(true);
        API.get(`/medicaments/patients/${patient.patientId}/traitements?page=${nextPage}&size=${TRAITEMENTS_PAGE_SIZE}`, { noRedirectOn401: true })
            .then(r => {
                const next = traitementsPageFromResponse(r.data, nextPage);
                setItems(current => nextPage === 0 ? next.content : [...current, ...next.content]);
                setPage(next.page);
                setTotalPages(next.totalPages);
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    const loadMore = useCallback(() => {
        if (!selectedPatient?.patientId || loading) return;
        if (!hasNextPage(page, totalPages)) return;
        select(selectedPatient, page + 1);
    }, [select, selectedPatient, loading, page, totalPages]);

    useEffect(() => {
        if (!active) return;
        if (selectedPatient && grouped.some(g => patientKey(g[0]) === patientKey(selectedPatient))) return;
        if (grouped.length > 0) select(grouped[0][0]);
        else {
            setSelectedPatient(null);
            setItems([]);
        }
    }, [active, grouped, select, selectedPatient]);

    const markRetraited = useCallback(id => {
        setItems(prev => prev.map(t => t.id === id ? retraitedTraitement(t) : t));
    }, []);

    return {
        selectedPatient,
        selectedKey: selectedPatient ? patientKey(selectedPatient) : null,
        items,
        loading,
        hasMore: hasNextPage(page, totalPages),
        select,
        loadMore,
        markRetraited,
    };
}
